import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, space, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Table', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}-wrapper ${componentCls}${DOT_PREFIX}`]: {
      transition,
      background: 'transparent',

      // 表头
      [`${componentCls}-thead > tr > th, ${componentCls}-thead > tr > td`]: {
        background: `${cyan[500]}06 !important`,
        borderBottom: `1px solid ${cyan[500]}18 !important`,
        color: `${cyan[300]} !important`,
        fontWeight: 600,
        letterSpacing: '0.5px',
        fontSize: '12px',
        textTransform: 'uppercase' as const,
      },

      // 表体行
      [`${componentCls}-tbody > tr > td`]: {
        borderBottom: `1px solid ${cyan[500]}0a !important`,
        transition,
      },

      // 行 hover
      [`${componentCls}-tbody > tr:hover > td`]: {
        background: `${cyan[500]}0a !important`,
      },

      // 选中行
      [`${componentCls}-tbody > tr${componentCls}-row-selected > td`]: {
        background: `${cyan[500]}12 !important`,
      },

      // 固定列阴影
      [`${componentCls}-cell-fix-left, ${componentCls}-cell-fix-right`]: {
        background: `${space[800]} !important`,
      },
    },
  }
})
